module.exports = __webpack_public_path__ + "img/lemonade.c4c6282e.jpg";